import React from 'react';
import LabelText from '../../LabelText';
import Year from './Year';
import Month from './Month';
import Day from './Day';
import Calendar from './Calendar';

const Birthday = (props) => {
	const {form_component} = props;
	const {date_display, required, show_date_year, show_date_month, show_date_day} = form_component;

	return (
		<div className={`flex-grow-1 form-group text ${required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			{date_display === 'calendar' ? (
				<Calendar
					lang={props.lang}
					form_component={form_component}
				/>
			) : (
				<div className="d-flex align-items-center flex-wrap gap-2">
					{show_date_year && (
						<Year
							lang={props.lang}
							form_component={form_component}
						/>
					)}
					{show_date_month && (
						<Month
							lang={props.lang}
							form_component={form_component}
						/>
					)}
					{show_date_day && (
						<Day
							lang={props.lang}
							form_component={form_component}
						/>
					)}
				</div>
			)}
		</div>
	);
}

export default Birthday;
